<script setup>
import ImgMedia from '../Images/ImgMedia.vue';

const props = defineProps({
    title: String,
    text: String,
    image: Object,
    page: Object,
});
</script>
<template>
    <div class="relative overflow-hidden bg-gray-light">
        <div v-if="image" class="absolute top-0 left-0 z-20 w-full h-full"></div>

        <ImgMedia v-if="image" eager :media="image"
            :classes="'object-cover w-full h-[500px] xl:h-[550px] absolute top-0 left-0 z-10'" />

        <div class="container relative z-30 flex items-center min-h-[250px] xl:min-h-[300px]">
            <div class="flex flex-col gap-4 py-12">
                <h1 class="m-0" :class="{ 'text-bodyColor': !image, 'text-white': image }" v-if="title || page">
                    {{ title ?? page.title }}
                </h1>
                <div v-if="text" v-html="text" class="max-w-full prose" :class="{
                    'text-bodyColor marker:text-primary': !image,
                    'text-white prose-strong:text-white': image,
                }"></div>
            </div>
        </div>
    </div>
</template>
